var _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppBgRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 275,
    viewBox: "0 0 275 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 137.042,
    cy: 137.808,
    r: 137.011,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.0148 189.545L61.1302 189.352L64.0549 184.256C56.2121 171.076 52.0174 155.976 52.0174 140.21C52.0174 117.234 60.907 95.6365 77.0545 79.3901C93.2021 63.1437 114.668 54.1996 137.504 54.1996C160.34 54.1996 181.806 63.1437 197.953 79.3901C214.101 95.6365 222.99 117.234 222.99 140.21C222.99 155.968 218.788 171.076 210.953 184.256L213.877 189.352L214.709 190.807L228.016 214C244.264 193.851 254 168.18 254 140.217C253.992 75.4795 201.832 23 137.496 23C73.16 23 21 75.4795 21 140.21C21 168.172 30.7362 193.851 46.9838 213.992L61.0148 189.545Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.0300903,
    y1: 0.796875,
    x2: 274.053,
    y2: 274.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3315F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppBgRed);
export default __webpack_public_path__ + "static/media/app-bg-red.628f11277af188b52be58cc871eec403.svg";
export { ForwardRef as ReactComponent };